import styled from 'styled-components';

const FieldWrap = styled.div`
    & > label {
        display: block;
    }
`;

export default FieldWrap;
